import {
    Box,
    FormErrorMessage,
    VStack,
    IconButton,
    InputGroup,
    InputRightElement,
} from '@chakra-ui/react';
import { MdContentCopy } from 'react-icons/md';
import { Input } from '@/components/v4';
import { textBoxStyling } from '../formStyles';

const NameField = ({
    field,
    error,
    darkMode,
    walkthroughid,
    isReadOnly,
    multiline,
    copyable,
    sx: sxProp,
    ...restProps
}) => {
    const inputStyles = {
        ...textBoxStyling,
        ...(darkMode && {}),
        ...(multiline && {
            height: 'auto',
            minHeight: '80px',
            paddingTop: '8px',
            paddingBottom: '8px',
            resize: 'vertical',
            alignItems: 'flex-start',
            verticalAlign: 'top',
            textAlign: 'left',
        }),
        ...sxProp,
    };
    if (isReadOnly) {
        inputStyles.pointerEvents = 'none';
    }
    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'flex-start',
                paddingTop: '15px',
            }}>
            <VStack width="100%" alignItems="normal">
                {copyable ? (
                    <InputGroup>
                        <Input
                            {...field}
                            {...restProps}
                            as={multiline ? 'textarea' : undefined}
                            sx={inputStyles}
                            data-walkthroughid={walkthroughid}
                        />
                        <InputRightElement height="100%" width="1.75rem">
                            <IconButton
                                aria-label="Copy value"
                                icon={
                                    <MdContentCopy
                                        color="gray"
                                        fontSize="13px"
                                    />
                                }
                                size="xs"
                                minW="unset"
                                w="1.5rem"
                                h="1.5rem"
                                variant="ghost"
                                _hover={{
                                    bg: darkMode
                                        ? 'whiteAlpha.200'
                                        : 'blackAlpha.100',
                                }}
                                _active={{
                                    bg: darkMode
                                        ? 'whiteAlpha.300'
                                        : 'blackAlpha.200',
                                }}
                                onClick={() =>
                                    navigator.clipboard.writeText(
                                        field?.value ?? '',
                                    )
                                }
                            />
                        </InputRightElement>
                    </InputGroup>
                ) : (
                    <Input
                        {...field}
                        {...restProps}
                        as={multiline ? 'textarea' : undefined}
                        sx={inputStyles}
                        data-walkthroughid={walkthroughid}
                    />
                )}
                {error && (
                    <FormErrorMessage
                        display="flex"
                        sx={{ marginTop: '0 !important', fontSize: '10px' }}
                        justifyContent="flex-end">
                        {error}
                    </FormErrorMessage>
                )}
            </VStack>
        </Box>
    );
};

export default NameField;
